import React from 'react'
import { insomniCatalog2, InsomnioCatalog, InsomnioOptions } from '../../../../escalas/insomnio/insomnio.catalog'


// Example of "insomnio": [ 0, 1, 2, 2, 3, 4, 0 ]

// Responses at InsomnioOptions and included in the InsomnioCatalog2

function getInsomnioInterpretation(score) {
  if (score <= 7) return 'Sin insomnio clínicamente significativo'
  if (score <= 14) return 'Insomnio subumbral'
  if (score <= 21) return 'Insomnio clínico moderado'
  return 'Insomnio clínico severo'
}

export default function InsomnioResults({insomnio}) {
  if (!insomnio) return null

  const score = insomnio.reduce((a, v) => a + v, 0)

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score} / 28</strong></td>
        <td><strong>{getInsomnioInterpretation(score)}</strong></td>
      </tr>
      {InsomnioCatalog.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{InsomnioOptions[insomnio[i]]?.label}</td>
        </tr>
      ))}
      {insomniCatalog2.map((item, i) => (
        <tr key={i + 3} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#fff' : '#f5f5f5', padding: 5, borderRadius: 6 }}>
          <td>{item.label}</td>
          <td>{item.responses[insomnio[i + 3]]}</td>
        </tr>
      ))}
    </div>
  )
}